import React from "react";
import c from "./ContainerWithBorder.module.css";

export default function ContainerWithBorder({
  children,
  fillHeight,
}: {
  children: React.ReactNode;
  fillHeight?: boolean;
}): React.ReactElement {
  return <div className={c.bordered + (fillHeight ? " " + c.fillHeight : "")}>{children}</div>;
}
